import { default as FloorplanRoutes } from '../modules/floorplan/routes';
import { NotFound } from '../modules/404';

import Root from '../modules/root';


export default {
  childRoutes: [
    {
      path: '/',
      component: Root,
      childRoutes: [...FloorplanRoutes, ...NotFound],
    },
  ],
};



/** WEBPACK FOOTER **
 ** ./src/app/routes/index.js
 **/